import useUrlQueryParams from './useUrlQueryParams';
import SearchParams from '../constants/SearchParams';

const useIsESigLoginContext = () => {
    const searchParams = useUrlQueryParams();
    const path = window.location.pathname;

    const isLoginPageRoute = path.startsWith('/login') || path === '/';

    if (!isLoginPageRoute) {
        return false;
    }

    return searchParams.get(SearchParams.ESIG) === 'true';
};

export default useIsESigLoginContext;
